import cx from 'classnames';
import Image from 'next/image';

import {Text} from '#component/base';
import {HoverEffect} from '#component/util';
import {ImpactLevel} from '#constant/impactLevel';
import {sprinkles} from '#style/sprinkles';

import {HealthFactorCompactCardProps} from './HealthFactorCompactCard.types';

import * as css from './HealthFactorCompactCard.css';

/**
 * This component renders a more compact variant of the HealthFactor Card UI.
 */
export const HealthFactorCompactCard = <T extends React.ElementType>({
  className,
  ctaLabel,
  eyebrow,
  headline,
  imageUrl,
  impact = ImpactLevel.low,
  practicing,
  ...otherProps
}: HealthFactorCompactCardProps<T>) => (
  <Text className={cx(css.root({impact, practicing}), className)} {...otherProps}>
    {imageUrl && (
      <div className={css.image}>
        <Image aria-hidden alt="" src={imageUrl} height={156} width={156} />
      </div>
    )}

    <div
      className={sprinkles({
        flex: 'flex',
        dir: 'col',
        gap: 20,
        pos: 'relative',
      })}>
      <Text color={practicing ? 'burgundy' : 'inherit'} textAlign="left" variant="caption">
        {eyebrow}
      </Text>

      <Text
        as="h4"
        className={sprinkles({pR: imageUrl ? 56 : 0})}
        color="inherit"
        fontWeight="semiBold"
        textAlign="left"
        variant="heading4">
        {headline}
      </Text>
    </div>

    {ctaLabel && (
      <Text
        color={practicing ? 'eggplantDark' : 'inherit'}
        className={css.button}
        variant="buttonSmall">
        {ctaLabel}
      </Text>
    )}
    <HoverEffect variant={impact ? impact : 'primary'} />
  </Text>
);
